import { jsxs as e, jsx as r } from "react/jsx-runtime";
const n = (o) => /* @__PURE__ */ e("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...o, children: [
  /* @__PURE__ */ r("path", { d: "M16.556 1H7.444L1 7.444V16.556L7.444 23H16.556L23 16.556V7.444L16.556 1Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M12 7V13", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z", fill: "currentColor" })
] });
export {
  n as default
};
//# sourceMappingURL=error.js.map
